import React from 'react';

const BtnLimit = ({
  query,
  onQuery,
}) => (
  <select
    className="custom-select custom-select-sm"
    value={query.limit}
    onChange={(e) => onQuery({
      ...query,
      limit: e.target.value,
    })}
  >
    <option value="20">每頁顯示20條</option>
    <option value="40">每頁顯示40條</option>
    <option value="60">每頁顯示60條</option>
  </select>
);

export default BtnLimit;
